import { render } from "./CartItem.vue?vue&type=template&id=39a80b66"
import script from "./CartItem.vue?vue&type=script&lang=js"
export * from "./CartItem.vue?vue&type=script&lang=js"

import "./CartItem.vue?vue&type=style&index=0&id=39a80b66&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__